import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Catalog } from "@modules/catalogs/types/catalog";
import { ListCatalogsQueryFilters } from "./types";

export async function getCatalogsService(filters?: ListCatalogsQueryFilters): Promise<Catalog[]> {
  try {
    const { data } = await api.get<ApiResponse<Catalog>>(`v1/plan_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching catalogs:", error);
    throw error;
  }
}
